import React, { useMemo } from 'react';
import {
  AppButton,
  Box,
  Inscription,
  RoundDoneIcon,
  Text,
} from '@common-fe/common-fe';

import { ModalWrapper } from '@/components/wrappers';

import { usePlanTerminationModalStore, usePlanTerminationSuccessModalStore } from './store';

export const PlanTerminationSuccessModal = () => {
  const modalVisible = usePlanTerminationSuccessModalStore((state) => state.modalVisible);
  const handleChangeVisibility = usePlanTerminationSuccessModalStore((state) => state.handleChangeVisibility);

  const planName = usePlanTerminationModalStore((state) => state.planName);
  const terminationDate = usePlanTerminationModalStore((state) => state.terminationDate);
  const handleReset = usePlanTerminationModalStore((state) => state.handleReset);
  const additionalAction = usePlanTerminationModalStore((state) => state.additionalAction);

  const headerText = useMemo(() => `${planName} is scheduled for termination`,[planName]);
  const description = useMemo(() => `Please note that you can edit or cancel termination configurations until ${terminationDate}.`, [terminationDate]);

  const onSubmit = () => {
    handleChangeVisibility(false);
    additionalAction?.();
    handleReset();
  };
  return (
    <ModalWrapper testId="PlanTerminationSuccessModal" visible={modalVisible} onSetVisible={onSubmit}>
      <Box align="center" pad={{ vertical: 'spacing24', horizontal: 'spacing24' }}>
        <RoundDoneIcon />
        <Inscription
          data-testid="PlanTerminationSuccessModal_header"
          margin={{ vertical: 'spacing12' }}
          textAlign="center"
          size="24px"
          weight={700}
          lineHeight="32px"
        >
          {headerText}
        </Inscription>

        <Text
          data-testid="PlanTerminationSuccessModal_description"
          margin={{ bottom: 'spacing24' }}
          textAlign="center"
        >
          {description}
        </Text>

        <AppButton
          testId="PlanTerminationSuccessModal"
          onClick={onSubmit}
          width="200px"
        >
          Got It!
        </AppButton>
      </Box>
    </ModalWrapper>
  );
};